
const messageCenter = {
  state: {
    HeaderMessageCenterShow: false,
    systemMessageList: [],
    noticeMessageList: [],
    newNoticeMessage: false,
    newSystemMessage: false,
    tabName: 'noticeMessage',
    total: 0
  },
  mutations: {
    // 显示隐藏头部消息中心
    CHANGE_MESSAGE_CENTER_SHOW: (state, status) => {
      state.HeaderMessageCenterShow = status;
    },
    // 改变tab名字
    CHANGE_TAB_NAME: (state, status) => {
      state.tabName = status;
    },
    // 通知消息列表
    GET_NOTICE_MESSAGE_LIST: (state, arr) => {
      state.noticeMessageList = arr;
    },
    // 系统消息列表
    GET_SYSTEM_MESSAGE_LIST: (state, arr) => {
      state.systemMessageList = arr;
    },
    // 通知消息新消息显示
    NEW_NOTICE_MESSAGE: (state, status) => {
      state.newNoticeMessage = status;
    },
    // 系统消息新消息显示
    NEW_SYSTEM_MESSAGE: (state, status) => {
      state.newSystemMessage = status;
    },
    SET_TOTAL: (state, status) => {
      state.total = status;
    }
  },
  actions: {
    GET_MESSAGE_DATA(content, obj) {
      // console.log(obj.params)
      obj.that.$post('/notification/notifications', obj.params,"port").then((response) => {         
        let arr = [];
        response.data.list.forEach(element => {
          element.createTime = changeFormat(element.createTime);
          arr.push(element.readFlag)
          // element.createTime = changeFormat('2019-06-13 19:36:50')
          switch (element.notificationType) {
            case 0: // 园长信箱
              element.routingPath =
                "/moduleIndex/notificationManagement/chiefMailbox";
              element.type = "[园长信箱]";
              break;
            case 1: // 学生请假
              element.routingPath =
                "/moduleIndex/notificationManagement/studentLeaveList";
              element.type = "[学生请假]";
              break;
            case 2: // 招生管理
              element.routingPath =
                "/moduleIndex/enrollAndRecruit/enrollmentManagement";
              element.type = "[招生管理]";
              break;
            case 3: // 意见反馈
              element.routingPath =
                "/moduleIndex/notificationManagement/suggest";
              element.type = "[意见反馈]";
              break;
            case 4: // 园所课程管理
              element.routingPath =
                "/moduleIndex/courseManagement/gardenCourseManagement";
              element.type = "[课程]";
              break;
            case 5: // 班级课程
              element.routingPath =
                "/moduleIndex/courseManagement/classCourse";
              element.type = "[课程]";
              break;
            case 6: // 添加课程一级评论
              element.routingPath =
                "/moduleIndex/courseManagement/classCourse";
              element.type = "[课程]";
              break;
            case 7: // 添加课程二级评论
              element.routingPath =
                "/moduleIndex/courseManagement/classCourse";
              element.type = "[课程]";
              break;
          }
        });
        if (obj.params.notificationCategory == 1) {// 通知消息
          content.commit("GET_NOTICE_MESSAGE_LIST", response.data.list);
          response.data.list.forEach(ele => {
            if (ele.readFlag == 0) {
              content.commit("NEW_NOTICE_MESSAGE", true);
            }
          });
          content.commit("SET_TOTAL", response.data.total);
        } else if (obj.params.notificationCategory == 0) {// 系统消息
          content.commit("GET_SYSTEM_MESSAGE_LIST", response.data.list);
          response.data.list.forEach(ele => {
            if (ele.readFlag == 0) {
              content.commit("NEW_SYSTEM_MESSAGE", true);
            }
          });
          content.commit("SET_TOTAL", response.data.total);
        } else {
          response.data.list.forEach(ele => {
            if (ele.readFlag == 0) {
              if (ele.notificationCategory == 1) {
                content.commit("NEW_NOTICE_MESSAGE", true);
              } else if (ele.notificationCategory == 0) {
                content.commit("NEW_SYSTEM_MESSAGE", true);
              }
            }
          });
        }
      }).catch(function (error) {
          console.log(error);
      });
    },
    ALL_READ(content, obj) {
      console.log(obj.params)
      obj.that.$post('/notification/setReadFlag', {
        all:obj.params.all,
        notificationCategory: obj.params.notificationCategory,
        userId: obj.params.userId,
        id: obj.params.id
      }).then((response) => {         
        console.log('全部已读成功')
        let params = {
          userId: sessionStorage.getItem("user_id"),
          pageNo: 1,
          pageSize: 12,
          notificationCategory: obj.params.notificationCategory,
          notificationType: null
        }
        if (obj.params.path == 'header') {
          params.pageSize = 20;
        }
        if (obj.params.notificationCategory == 1) {
          content.commit("NEW_NOTICE_MESSAGE", false);
        } else {
          content.commit("NEW_SYSTEM_MESSAGE", false);
        }
        return content.dispatch('GET_MESSAGE_DATA', {
          that: obj.that,
          params: params
        }).then(() => {
          console.log('成功')
        })
          // if (obj.params.all && obj.params.notificationCategory == 1) {
          //   content.state.noticeMessageList.forEach((ele) => {
          //     ele.readFlag = 1;
          //   })
          //   content.commit("GET_NOTICE_MESSAGE_LIST", content.state.noticeMessageList);
          // } else if (obj.params.all && obj.params.notificationCategory == 0) {
          //   content.state.systemMessageList.forEach((ele) => {
          //     ele.readFlag = 1;
          //   })
          //   content.commit("GET_SYSTEM_MESSAGE_LIST", content.state.systemMessageList);
          // } else {
          //   content.state.systemMessageList.forEach((ele) => {
          //     if (obj.params.id == ele.id) {
          //       ele.readFlag = 1;
          //     }
          //   })
          //   content.commit("GET_SYSTEM_MESSAGE_LIST", content.state.systemMessageList);
          // }
      }).catch(function (error) {
          console.log(error);
      });
    }
  }
}
function changeFormat(time) {
  // 今天显示10:00  今年显示09/09  去年之前的只显示年份
  let year = time.slice(0, 4);
  let month = time.slice(5, 7);
  let date = time.slice(8, 10);
  let times = time.slice(11, 16);
  var myDate = new Date();
  let thisYear = myDate.getFullYear();
  let thisMonth =
    myDate.getMonth() + 1 > 10
      ? myDate.getMonth() + 1
      : "0" + (myDate.getMonth() + 1);
  let thisDate = myDate.getDate() > 10
  ? myDate.getDate()
  : "0" + myDate.getDate();
  if (year < thisYear) {
    return year;
  } else if (year >= thisYear && thisDate != date){
    return month + '/' + date;
  } else if (year == thisYear && month == thisMonth && thisDate == date){
    return times;
  } 
}
export default messageCenter



// WEBPACK FOOTER //
// ./src/store/modules/messageCenter.js